import { jsx as r } from "react/jsx-runtime";
const e = ({
  size: L
}) => {
  switch (L) {
    case "sm":
      return /* @__PURE__ */ r(
        "path",
        {
          d: "M4.91533 8.5L8.71283 12.2975L8 13L3 8L8 3L8.71283 3.7025L4.91533 7.5H13V8.5H4.91533Z",
          fill: "currentColor"
        }
      );
    case "lg":
      return /* @__PURE__ */ r(
        "path",
        {
          d: "M7.373 12.75L13.0693 18.4462L12 19.5L4.5 12L12 4.5L13.0693 5.55375L7.373 11.25H19.5V12.75H7.373Z",
          fill: "currentColor"
        }
      );
    case "md":
    default:
      return /* @__PURE__ */ r(
        "path",
        {
          d: "M6.14417 10.625L10.891 15.3719L10 16.25L3.75 10L10 3.75L10.891 4.62813L6.14417 9.375H16.25V10.625H6.14417Z",
          fill: "currentColor"
        }
      );
  }
}, o = ({
  size: L
}) => {
  switch (L) {
    case "sm":
      return /* @__PURE__ */ r(
        "path",
        {
          d: "M5.4347 8.7572L9.08036 12.4029L7.99886 13.4677L2.53003 7.99886L7.99886 2.53003L9.08036 3.59486L5.4347 7.24053H13.4677V8.7572H5.4347Z",
          fill: "currentColor"
        }
      );
    case "lg":
      return /* @__PURE__ */ r(
        "path",
        {
          d: "M8.15198 13.1357L13.6205 18.6042L11.9982 20.2014L3.79498 11.9982L11.9982 3.79492L13.6205 5.39217L8.15198 10.8607H20.2015V13.1357H8.15198Z",
          fill: "currentColor"
        }
      );
    case "md":
    default:
      return /* @__PURE__ */ r(
        "path",
        {
          d: "M6.79581 10.949L11.3529 15.5061L10.001 16.8371L3.16498 10.0011L10.001 3.16504L11.3529 4.49608L6.79581 9.05316H16.8371V10.949H6.79581Z",
          fill: "currentColor"
        }
      );
  }
}, c = ({
  size: L = "md",
  weight: t = "default"
}) => {
  switch (t) {
    case "bold":
      return /* @__PURE__ */ r(o, { size: L });
    case "book":
    case "default":
      return /* @__PURE__ */ r(e, { size: L });
  }
};
export {
  c as default
};
//# sourceMappingURL=DIconArrowLeft.js.map
